import request from '@/utils/request'

export function getPriceCategoryApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-category',
    method: 'get',
    params: query
  })
}
